
import createIconComponent from '../utils/createIconComponent';
import { SVG_LOGMEIN_BLACK_YELLOW } from '../../../dist';
import React from 'react';
const LogmeinBlackYellowIcon = createIconComponent({ content: SVG_LOGMEIN_BLACK_YELLOW, height: 24, width: 85 });
LogmeinBlackYellowIcon.displayName = 'LogmeinBlackYellowIcon';
export default LogmeinBlackYellowIcon;
